export default {
    "common-butterfly": { 
        name: 'Common Butterfly',
        price: 160,
        location: 'Flying',
        time: 2,
        allYear: false,
        monthsN: [1,2,3,4,5,6,9,10,11,12],
        monthsS: [3,4,5,6,7,8,9,10,11,12]
    },
    "yellow-butterfly": { 
        name: 'Yellow Butterfly',
        price: 160,
        location: 'Flying',
        time: 2,
        allYear: false,
        monthsN: [9,10,11,12,1,2,3,4,5,6],
        monthsS: [3,4,9,10,11,12]
    },
    "tiger-butterfly": { 
        name: 'Tiger Butterfly',
        price: 240,
        location: 'Flying',
        time: 2,
        allYear: false,
        monthsN: [3,4,5,6,7,8,9],
        monthsS: [1,2,3,9,10,11,12]
    },
    "peacock-butterfly": { 
        name: 'Peacock Butterfly',
        price: 2500,
        location: 'Flying(rare flowers)',
        time: 2,
        allYear: false,
        monthsN: [3,4,5,6],
        monthsS: [9,10,11,12]
    },
    "common-bluebottle": { 
        name: 'Common Bluebottle',
        price: 300,
        location: 'Flying',
        time: 2,
        allYear: false,
        monthsN: [4,5,6,7,8],
        monthsS: [10,11,12,1,2]
    },
    "paper-kite-butterfly": { 
        name: 'Paper Kite Butterfly',
        price: 1000,
        location: 'Flying',
        time: 4,
        allYear: true,
        monthsN: [],
        monthsS: []
    },
    "great-purple-emperor": { 
        name: 'Great Purple Emperor',
        price: null,//no price on website
        location: 'Flying',
        time: 2,
        allYear: false,
        monthsN: [5,6,7,8],
        monthsS: [12,1,2,3]
    },
    "monarch-butterfly": { 
        name: 'Monarch Butterfly',
        price: 140,
        location: 'Flying',
        time: 11,
        allYear: false,
        monthsN: [9,10,11],
        monthsS: [3,4,5]
    },
    "emperor-butterfly": { 
        name: 'Emperor Butterfly',
        price: 4000,
        location: 'Flying',
        time: 5,
        allYear: false,
        monthsN: [6,7,8,9,12,1,2,3],
        monthsS: [12,1,2,3,6,7,8,9]
    },
    "agrias-butterfly": { 
        name: 'Agrias Butterfly',
        price: 3000,
        location: 'Flying',
        time: 3,
        allYear: false,
        monthsN: [4,5,6,7,8,9],
        monthsS: [11,12,1,2,3]
    },
    "rajah-brookes-birdwing": { 
        name: "Rajah Brooke's Birdwing",
        price: 2500,
        location: 'Flying',
        time: 3,
        allYear: false,
        monthsN: [1,2,4,5,6,7,8,9,12],
        monthsS: [11,12,1,2,3,6,7,8]
    },
    "queen-alexandras-birdwing": { 
        name: "Queen Alexandra's Birdwing",
        price: 4000,
        location: 'Flying',
        time: 12,
        allYear: false,
        monthsN: [5,6,7,8,9],
        monthsS: [11,12,1,2,3]
    },
    "moth": { 
        name: 'Moth',
        price: 130,
        location: 'Flying(light)',
        time: 6,
        allYear: true,
        monthsN: [],
        monthsS: []
    },
    "atlas-moth": { 
        name: 'Atlas Moth',
        price: 3000,
        location: 'Trees',
        time: 6,
        allYear: false,
        monthsN: [4,5,6,7,8,9],
        monthsS: [10,11,12,1,2,3]
    },
    "madagascan-sunset-moth": { 
        name: 'Madagascan Sunset Moth',
        price: 2500,
        location: 'Flying',
        time: 12,
        allYear: false,
        monthsN: [4,5,6,7,8,9],
        monthsS: [10,11,12,1,2,3]
    },
    "long-locust": { 
        name: 'Long Locust',
        price: 200,
        location: 'Hopping',
        time: 4,
        allYear: false,
        monthsN: [4,5,6,7,8,9,10,11],
        monthsS: [11,12,1,2,3,4,5]
    },
    "migratory-locust": { 
        name: 'Migratory Locust',
        price: 600,
        location: 'Hopping',
        time: 4,
        allYear: false,
        monthsN: [8,9,10,11],
        monthsS: [2,3,4,5]
    },
    "rice-grasshopper": { 
        name: 'Rice Grasshopper',
        price: 160,
        location: 'Hopping',
        time: 4,
        allYear: false,
        monthsN: [8,9,10,11],
        monthsS: [2,3,4,5]
    },
    "grasshopper": { 
        name: 'Grasshopper',
        price: 160,
        location: 'Hopping',
        time: 3,
        allYear: false,
        monthsN: [7,8,9],
        monthsS: [1,2,3]
    },
    "cricket": { 
        name: 'Cricket',
        price: 130,
        location: 'Hopping',
        time: 5,
        allYear: false,
        monthsN: [9,10,11],
        monthsS: [3,4,5]
    },
    "bell-cricket": { 
        name: 'Bell Cricket',
        price: 430,
        location: 'Hopping',
        time: 5,
        allYear: false,
        monthsN: [9,10],
        monthsS: [3,4]
    },
    "mantis": { 
        name: 'Mantis',
        price: 430,
        location: 'Flowers',
        time: 3,
        allYear: false,
        monthsN: [3,4,5,6,7,8,9,10,11],
        monthsS: [9,10,11,12,1,2,3,4,5]
    },
    "orchid-mantis": { 
        name: 'Orchid Mantis',
        price: 2400,
        location: 'Flowers(white)',
        time: 3,
        allYear: false,
        monthsN: [3,4,5,6,7,8,9,10,11],
        monthsS: [9,10,11,12,1,2,3,4,5]
    },
    "honeybee": { 
        name: 'Honeybee',
        price: 200,
        location: 'Flying',
        time: 3,
        allYear: false,
        monthsN: [3,4,5,6,7],
        monthsS: [3,4,5,6,7]
    },
    "wasp": { 
        name: 'Wasp',
        price: 2500,
        location: 'Shake tree',
        time: 1,
        allYear: true,
        monthsN: [],
        monthsS: []
    },
    "brown-cicada": { 
        name: 'Brown Cicada',
        price: null,
        location: 'Trees',
        time: 3,
        allYear: false,
        monthsN: [7,8],
        monthsS: [1,2]
    },
    "robust-cicada": { 
        name: 'Robust Cicada',
        price: null,
        location: 'Trees',
        time: 3,
        allYear: false,
        monthsN: [7,8],
        monthsS: [1,2]
    },
    "giant-cicada": { 
        name: 'Giant Cicada',
        price: null,
        location: 'Trees',
        time: 3,
        allYear: false,
        monthsN: [7,8],
        monthsS: [1,2]
    },
    "walker-cicada": { 
        name: 'Walker Cicada',
        price: 400,
        location: 'Trees',
        time: 3,
        allYear: false,
        monthsN: [8,9],
        monthsS: [2,3]
    },
    "evening-cicada": { 
        name: 'Evening Cicada',
        price: null,
        location: 'Trees',
        time: 17,
        allYear: false,
        monthsN: [7,8],
        monthsS: [1,2]
    },
    "cicada-shell": { 
        name: 'Cicada Shell',
        price: null,
        location: 'Trees',
        time: 1,
        allYear: false,
        monthsN: [8,9],
        monthsS: [1,2]
    },
    "red-dragonfly": { 
        name: 'Red Dragonfly',
        price: 180,
        location: 'Flying',
        time: 4,
        allYear: false,
        monthsN: [9,10],
        monthsS: [3,4]
    },
    "darner-dragonfly": { 
        name: 'Darner Dragonfly',
        price: 230,
        location: 'Flying',
        time: 3,
        allYear: false,
        monthsN: [4,5,6,7,8,9,10],
        monthsS: [10,1,2,3,4]
    },
    "banded-dragonfly": { 
        name: 'Banded Dragonfly',
        price: 4500,
        location: 'Flying',
        time: 3,
        allYear: false,
        monthsN: [5,6,7,8,9,10],
        monthsS: [11,12,1,2,3,4]
    },
    "damselfly": { 
        name: 'Damselfly',
        price: null,
        location: 'Flying',
        time: 1,
        allYear: false,
        monthsN: [11,12,1,2],
        monthsS: [5,6,7,8]
    },
    "firefly": { 
        name: 'Firefly',
        price: null,
        location: 'Flying',
        time: 6,
        allYear: false,
        monthsN: [6],
        monthsS: [12]
    },
    "mole-cricket": { 
        name: 'Mole Cricket',
        price: 500,
        location: 'Underground',
        time: 1,
        allYear: false,
        monthsN: [11,12,1,2,3,4,5],
        monthsS: [5,6,7,8,9,10,11]
    },
    "pondskater": { 
        name: 'Pondskater',
        price: 130,
        location: 'Ponds',
        time: 4,
        allYear: false,
        monthsN: [5,6,7,8,9],
        monthsS: [11,12,1,2,3]
    },
    "diving-beetle": { 
        name: 'Diving Beetle',
        price: 800,
        location: 'Ponds and rivers',
        time: 4,
        allYear: false,
        monthsN: [5,6,7,8,9],
        monthsS: [11,12,1,2,3]
    },
    "giant-water-bug": { 
        name: 'Giant Water Bug',
        price: 2000,
        location: 'Ponds and rivers',
        time: 7,
        allYear: false,
        monthsN: [4,5,6,7,8,9],
        monthsS: [10,11,12,1,2,3]
    },
    "stinkbug": { 
        name: 'Stinkbug',
        price: 120,
        location: 'Flowers',
        time: 1,
        allYear: false,
        monthsN: [3,4,5,6,7,8,9,10,11],
        monthsS: [9,10,11,12,1,2,3,4,5]
    },
    "man-faced-stink-bug": { 
        name: 'Man-faced Stink Bug',
        price: 1000,
        location: 'Flowers',
        time: 7,
        allYear: false,
        monthsN: [3,4,5,6,7,8,9,10,11],
        monthsS: [9,10,11,12,1,2,3,4,5]
    },
    "ladybug": { 
        name: 'Ladybug',
        price: 200,
        location: 'Flowers',
        time: 3,
        allYear: false,
        monthsN: [3,4,5,6,10],
        monthsS: [9,10,11,12,4]
    },
    "tiger-beetle": { 
        name: 'Tiger Beetle',
        price: 1500,
        location: 'Ground',
        time: 1,
        allYear: false,
        monthsN: [2,3,4,5,6,7,8,9,10,11],
        monthsS: [8,9,10,11,12,1,2,3,4,5]
    },
    "jewel-beetle": { 
        name: 'Jewel Beetle',
        price: 2400,
        location: 'Trees',
        time: 1,
        allYear: false,
        monthsN: [4,5,6,7,8],
        monthsS: [10,11,12,1,2]
    },
    "violin-beetle": { 
        name: 'Violin Beetle',
        price: 450,
        location: 'Tree stumps',
        time: 1,
        allYear: false,
        monthsN: [5,6,9,10,11],
        monthsS: [11,12,3,4]
    },
    "citrus-long-horned-beetle": { 
        name: 'Citrus Long-horned Beetle',
        price: 350,
        location: 'Tree stumps',
        time: 1,
        allYear: true,
        monthsN: [],
        monthsS: []
    },
    "rosalia-batesi-beetle": { 
        name: 'Rosalia Batesi Beetle',
        price: 3000,
        location: 'Tree stumps',
        time: 1,
        allYear: false,
        monthsN: [5,6,7,8,9],
        monthsS: [11,12,1,2,3]
    },
    "blue-weevil-beetle": { 
        name: 'Blue Weevil Beetle',
        price: null,
        location: 'Unknown',
        time: 1,
        allYear: false,
        monthsN: [7,8],
        monthsS: [1,2]
    },
    "dung-beetle": { 
        name: 'Dung Beetle',
        price: null,
        location: 'Ground',
        time: null,
        allYear: false,
        monthsN: [12,1,2],
        monthsS: [6,7,8]
    },
    "earth-boring-dung-beetle": { 
        name: 'Earth-boring Dung Beetle',
        price: 300,
        location: 'Ground',
        time: 1,
        allYear: false,
        monthsN: [7,8,9],
        monthsS: [1,2,3]
    },
    "scarab-beetle": { 
        name: 'Scarab Beetle',
        price: null,
        location: 'Trees',
        time: 8,
        allYear: false,
        monthsN: [7,8],
        monthsS: [1,2]
    },
    "drone-beetle": { 
        name: 'Drone Beetle',
        price: null,
        location: 'Trees',
        time: 1,
        allYear: false,
        monthsN: [6,7,8],
        monthsS: [12,1,2]
    },
    "goliath-beetle": { 
        name: 'Goliath Beetle',
        price: 8000,
        location: 'Trees',
        time: 5,
        allYear: false,
        monthsN: [6,7,8,9],
        monthsS: [12,1,2,3]
    },
    "saw-stag": { 
        name: 'Saw Stag',
        price: null,
        location: 'Trees',
        time: 1,
        allYear: false,
        monthsN: [7,8],
        monthsS: [1,2]
    },
    "miyama-stag": { 
        name: 'Miyama Stag',
        price: null,
        location: 'Trees',
        time: 1,
        allYear: false,
        monthsN: [7,8],
        monthsS: [1,2]
    },
    "giant-stag": { 
        name: 'Giant Stag',
        price: null,
        location: 'Trees',
        time: 8,
        allYear: false,
        monthsN: [7,8],
        monthsS: [1,2]
    },
    "rainbow-stag": { 
        name: 'Rainbow Stag',
        price: 6000,
        location: 'Trees',
        time: 7,
        allYear: false,
        monthsN: [6,7,8,9],
        monthsS: [12,1,2,3]
    },
    "cyclommatus-stag": { 
        name: 'Cyclommatus Stag',
        price: null,
        location: 'Trees',
        time: 5,
        allYear: false,
        monthsN: [7,8],
        monthsS: [1,2]
    },
    "golden-stag": { 
        name: 'Golden Stag',
        price: null,
        location: 'Trees',
        time: 5,
        allYear: false,
        monthsN: [7,8],
        monthsS: [1,2]
    },
    "giraffe-stag": { 
        name: 'Giraffe Stag',
        price: null,
        location: 'Trees',
        time: 5,
        allYear: false,
        monthsN: [7,8],
        monthsS: [1,2]
    },
    "horned-dynastid": { 
        name: 'Horned Dynastid',
        price: null,
        location: 'Trees',
        time: 5,
        allYear: false,
        monthsN: [7,8],
        monthsS: [1,2]
    },
    "horned-atlas": { 
        name: 'Horned Atlas',
        price: null,
        location: 'Trees',
        time: 5,
        allYear: false,
        monthsN: [7,8],
        monthsS: [1,2]
    },
    "horned-elephant": { 
        name: 'Horned Elephant',
        price: null,
        location: 'Trees',
        time: 5,
        allYear: false,
        monthsN: [7,8],
        monthsS: [1,2]
    },
    "horned-hercules": { 
        name: 'Horned Hercules',
        price: null,
        location: 'Trees',
        time: 5,
        allYear: false,
        monthsN: [7,8],
        monthsS: [1,2]
    },
    "walking-stick": { 
        name: 'Walking Stick',
        price: null,
        location: 'Shaking trees',
        time: 18,
        allYear: false,
        monthsN: [7,8,9,10,11],
        monthsS: [1,2,3,4,5]
    },
    "walking-leaf": { 
        name: 'Walking Leaf',
        price: null,
        location: 'Fake tree leaf',
        time: 1,
        allYear: false,
        monthsN: [7,8],
        monthsS: [1,2,3]
    },
    "bagworm": { 
        name: 'Bagworm',
        price: 600,
        location: 'Shaking trees',
        time: 1,
        allYear: true,
        monthsN: [],
        monthsS: []
    },
    "bagworm": { 
        name: 'Bagworm',
        price: 600,
        location: 'Shaking trees',
        time: 1,
        allYear: true,
        monthsN: [],
        monthsS: []
    },
    "ant": { 
        name: 'Ant',
        price: null,
        location: 'On rotten food',
        time: 1,
        allYear: true,
        monthsN: [],
        monthsS: []
    },
    "hermit-crab": { 
        name: 'Hermit Crab',
        price: 1000,
        location: 'Beach',
        time: 7,
        allYear: true,
        monthsN: [],
        monthsS: []
    },
    "wharf-roach": { 
        name: 'Wharf Roach',
        price: 200,
        location: 'Beach rocks',
        time: 1,
        allYear: true,
        monthsN: [],
        monthsS: []
    },
    "fly": { 
        name: 'Fly',
        price: null,
        location: 'Trash items',
        time: 1,
        allYear: true,
        monthsN: [],
        monthsS: []
    },
    "mosquito": { 
        name: 'Mosquito',
        price: 130,
        location: 'Flying',
        time: 16,
        allYear: false,
        monthsN: [6,7,8,9],
        monthsS: [12,1,2,3]
    },
    "flea": { 
        name: 'Flea',
        price: null,
        location: 'Villager head',
        time: 1,
        allYear: true,
        monthsN: [4,5,6,7,8,9,10,11],
        monthsS: [10,11,12,1,2,3,4,5]
    },
    "snail": { 
        name: 'Snail',
        price: 250,
        location: 'Rocks(raining)',
        time: 1,
        allYear: true,
        monthsN: [],
        monthsS: []
    },
    "pill-bug": { 
        name: 'Pill Bug',
        price: 250,
        location: 'Hit rocks',
        time: 9,
        allYear: false,
        monthsN: [9,10,11,12,1,2,3,4,5,6],
        monthsS: [3,4,5,6,7,8,9,10,11,12]
    },
    "centipede": { 
        name: 'Centipede',
        price: 300,
        location: 'Hit rocks',
        time: 10,
        allYear: false,
        monthsN: [9,10,11,12,1,2,3,4,5,6],
        monthsS: [3,4,5,6,7,8,9,10,11,12]
    },
    "spider": { 
        name: 'Spider',
        price: 480,
        location: 'Shaking trees',
        time: 7,
        allYear: true,
        monthsN: [],
        monthsS: []
    },
    "tarantula": { 
        name: 'Tarantula',
        price: 8000,
        location: 'Ground',
        time: 6,
        allYear: false,
        monthsN: [11,12,1,2,3,4],
        monthsS: [5,6,7,8,9,10]
    },
    "scorpion": { 
        name: 'Scorpion',
        price: 8000,
        location: 'Ground',
        time: 6,
        allYear: false,
        monthsN: [5,6,7,8,9,10],
        monthsS: [11,12,1,2,3,4]
    }
}